import { Select as RadixSelect } from "@radix-ui/themes";
import { FC } from "react";

export type SelectProps = {
  onChange?: (value: string) => void;
  defaultValue?: string;
  items?: Array<SelectItemType>;
};

type SelectItemType = {
  value: string;
  label: string;
  disabled?: boolean;
};

export const Select: FC<SelectProps> = (props) => {
  const { onChange, items, defaultValue } = props;
  return (
    <RadixSelect.Root defaultValue={defaultValue} onValueChange={onChange}>
      <RadixSelect.Trigger />
      <RadixSelect.Content>
        <RadixSelect.Group>
          {items?.map((item) => (
            <RadixSelect.Item
              key={item.value}
              value={item.value}
              disabled={item.disabled}
            >
              {item.label}
            </RadixSelect.Item>
          ))}
        </RadixSelect.Group>
      </RadixSelect.Content>
    </RadixSelect.Root>
  );
};
